import type { RadarStateResponse } from "./api";

export class RadarSequenceGate {
  private latest = -1;

  accept(state: RadarStateResponse): boolean {
    if (state.sequence <= this.latest) return false;
    this.latest = state.sequence;
    return true;
  }

  reset(): void {
    this.latest = -1;
  }
}
